import(/* webpackMode: "eager", webpackExports: ["CatLayoutContainer"] */ "/usr/server/app/apps/pcc-nextjs-bff/components/blocks-components.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/server/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
